import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  hero: {
    background: 'linear-gradient(180deg, #4C1D95 0%, #6D28D9 100%)',
    padding: theme.spacing(5, 6, 0, 6),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3.5, 2.5, 0, 2.5),
      gap: theme.spacing(0.75)
    }
  } as SxProps,

  heroLabel: {
    color: '#C4B5FD',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 2,
    textTransform: 'uppercase',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: 10
    }
  } as SxProps,

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  heroTitle: {
    color: '#FFFFFF',
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: 22
    }
  } as SxProps,

  desktopSupportGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  } as SxProps,

  needHelp: {
    color: '#C4B5FD',
    fontSize: 14
  } as SxProps,

  supportCta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    height: 36,
    padding: theme.spacing(0, 2),
    borderRadius: '8px',
    backgroundColor: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.19)',
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit'
  } as SxProps,

  supportCtaText: {
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: 600
  } as SxProps,

  heroSub: {
    color: '#C4B5FD',
    fontSize: 14,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: 12
    }
  } as SxProps,

  mobileSupportRow: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      width: '100%'
    }
  } as SxProps,

  mobileSupportNeedHelp: {
    color: '#C4B5FD',
    fontSize: 12
  } as SxProps,

  mobileSupportCta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.625),
    height: 28,
    padding: theme.spacing(0, 1.5),
    borderRadius: '6px',
    backgroundColor: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.19)',
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'pointer'
  } as SxProps,

  mobileSupportCtaText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 600
  } as SxProps,

  stepperWrapper: {
    paddingTop: theme.spacing(4),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2)
    }
  } as SxProps,

  trackingDetailsContainer: {
    paddingTop: theme.spacing(5),
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4),
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0
    }
  } as SxProps,

  stepperCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px 16px 0 0',
    height: 88,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      height: 80
    }
  } as SxProps,

  stepRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 6),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 2.5)
    }
  } as SxProps,

  stepItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    height: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: theme.spacing(0.5),
      alignItems: 'center'
    }
  } as SxProps,

  stepCircleCompleted: {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: '50%',
    backgroundColor: '#6D28D9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      width: 30,
      height: 30,
      minWidth: 30
    }
  } as SxProps,

  stepCircleActive: {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: '50%',
    backgroundColor: '#6D28D9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: '3px solid #DDD6FE',
    outlineOffset: '1px',
    [theme.breakpoints.down('md')]: {
      width: 30,
      height: 30,
      minWidth: 30
    }
  } as SxProps,

  stepCirclePending: {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: '50%',
    backgroundColor: '#F3F4F6',
    border: '2px solid #D1D5DB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      width: 30,
      height: 30,
      minWidth: 30
    }
  } as SxProps,

  stepNumActive: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1
  } as SxProps,

  stepNumPending: {
    color: '#9CA3AF',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1
  } as SxProps,

  stepLabels: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  } as SxProps,

  stepTitleCompleted: {
    color: '#1F2937',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'left'
  } as SxProps,

  stepTitleActive: {
    color: '#6D28D9',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'left'
  } as SxProps,

  stepTitlePending: {
    color: '#9CA3AF',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'left'
  } as SxProps,

  stepSubCompleted: {
    color: '#10B981',
    fontSize: 12,
    textAlign: 'left'
  } as SxProps,

  stepSubActive: {
    color: '#9F7AEA',
    fontSize: 12,
    textAlign: 'left'
  } as SxProps,

  stepSubPending: {
    color: '#D1D5DB',
    fontSize: 12,
    textAlign: 'left'
  } as SxProps,

  stepLabelMobileActive: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      color: '#6D28D9',
      fontSize: 9,
      fontWeight: 600,
      textAlign: 'center'
    }
  } as SxProps,

  stepLabelMobilePending: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      color: '#9CA3AF',
      fontSize: 9,
      textAlign: 'center'
    }
  } as SxProps,

  connectorCompleted: {
    flex: 1,
    height: 2,
    backgroundColor: '#6D28D9'
  } as SxProps,

  connectorPending: {
    flex: 1,
    height: 2,
    backgroundColor: '#E5E7EB'
  } as SxProps
}

export default styles
